import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-price",
  "use": "icon-price-usage",
  "viewBox": "0 0 384 384",
  "content": "<symbol viewBox=\"0 0 384 384\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-price\"><path d=\"m192 0c-105.871094 0-192 86.128906-192 192s86.128906 192 192 192c105.863281 0 192-86.128906 192-192s-86.136719-192-192-192zm0 352c-88.222656 0-160-71.777344-160-160s71.777344-160 160-160 160 71.777344 160 160-71.777344 160-160 160zm0 0\" /><path d=\"m192 128c13.230469 0 24 10.769531 24 24 0 8.832031 7.167969 16 16 16s16-7.167969 16-16c0-25.320312-16.894531-46.734375-40-53.640625v-18.359375c0-8.832031-7.167969-16-16-16s-16 7.167969-16 16v18.359375c-23.105469 6.90625-40 28.328125-40 53.640625 0 30.878906 25.121094 56 56 56 13.230469 0 24 10.769531 24 24s-10.769531 24-24 24-24-10.769531-24-24c0-8.832031-7.167969-16-16-16s-16 7.167969-16 16c0 25.320312 16.894531 46.734375 40 53.640625v18.359375c0 8.832031 7.167969 16 16 16s16-7.167969 16-16v-18.359375c23.105469-6.90625 40-28.328125 40-53.640625 0-30.878906-25.128906-56-56-56-13.230469 0-24-10.769531-24-24s10.769531-24 24-24zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/price.svg
// module id = Y2tI
// module chunks = 11